/**
 * avatarEvents — helper functions to dispatch avatar state-machine events
 * from anywhere in the dashboard without importing the hook.
 *
 * Usage:
 *   import { notifySpeakingStart, notifyProcessing } from '../lib/avatarEvents';
 *   notifySpeakingStart();  // alert → talking
 *   notifySpeakingStop();   // talking → idle
 *   notifyProcessing();     // idle → thinking
 *   notifySuccess();        // thinking → happy
 *   notifyError();           // thinking → sad
 *
 * For new messages / notifications, the existing `saik:notification`
 * CustomEvent (already dispatched by useNotifications) triggers the
 * alert state automatically.
 */

/** Dispatch NEW_MESSAGE — a new message arrived (chat opened, message received). */
export function notifyNewMessage() {
  window.dispatchEvent(new CustomEvent('saik:avatar-new-message'));
}

/** Dispatch USER_ACTIVITY — user interacted with the widget (chat opened/closed). */
export function notifyUserActivity() {
  window.dispatchEvent(new CustomEvent('saik:avatar-user-activity'));
}

/** Dispatch SPEAKING_START — AI chat response is starting. */
export function notifySpeakingStart() {
  window.dispatchEvent(new CustomEvent('saik:avatar-speaking-start'));
}

/** Dispatch SPEAKING_STOP — AI chat response finished. */
export function notifySpeakingStop() {
  window.dispatchEvent(new CustomEvent('saik:avatar-speaking-stop'));
}

/** Dispatch PROCESSING_START — AI is processing/thinking. */
export function notifyProcessing() {
  window.dispatchEvent(new CustomEvent('saik:avatar-processing'));
}

/** Dispatch SUCCESS — task completed successfully (message received OK). */
export function notifySuccess() {
  window.dispatchEvent(new CustomEvent('saik:avatar-success'));
}

/** Dispatch ERROR — an error occurred. */
export function notifyError() {
  window.dispatchEvent(new CustomEvent('saik:avatar-error'));
}